import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { VSLPage } from './pages/VSLPage';
import { LandingPage3 } from './pages/LandingPage3';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/lpd2" element={<VSLPage data-id="element-5" />} data-id="element-4" />
        <Route path="/lpd3" element={<LandingPage3 data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}